module.exports = __webpack_public_path__ + "img/linepay2.051a98bd.png";